'use strict';

export default class UsersController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = undefined;
  submitted = false;

  /*@ngInject*/
  constructor(Users, users) {
    this._Users = Users;
    this.users = users;
  }

  create() {
    this.submitted = true;
    this._Users.save(this.user)
      .then(res => {
        this.user = {};
        this.submitted = false;
        this.users.push(res);
        // Logged in, redirect to home
        // this.$state.go('main');
      })
      .catch(err => {
        console.log(err);
        this.errors = err.message;
      });
  }

  destroy(user) {
    this._Users.destroy(user)
      .then(() => {
        let index = this.users.indexOf(user);
        this.users.splice(index, 1);
        // Logged in, redirect to home
        // this.$state.go('main');
      })
      .catch(err => {
        console.log(err);
        this.errors = err.message;
      });
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/users.controller.js